import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_main/campaigns/$campaignId/settings/try-out')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/campaigns/$campaignId/settings/content',
            params,
            search: { test: true },
        })
    },
})
